export const CROP_SIZE = 256;
